module.exports = __webpack_public_path__ + "img/circle_02_focus2.43dda9ef.svg";